export class GetKpisAction {
    static readonly type = "[Kpi] Get Kpis";
    constructor(public siteId?: string) {}
}

export class SortKpisAction{
    static readonly type = "[Kpi] Sort Kpis";
    constructor(public columnToOrder: string, public isOrderingAscending: boolean) {}
}